<template>
  <div>
    <swiper ref="imgSwiper" class="swiper" :options="imgSwiperOption">
      <swiper-slide v-for="(item, index) in imgList" :key="index" class="slide">
        <img :src="imageSrc(item)" :alt="item">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
export default {
  name: 'ClubImgSlider',
  components: {
    Swiper,
    SwiperSlide
  },
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      imgSwiperOption: {
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      }
    }
  },
  methods: {
    imageSrc(imgSrc) {
      return require('@/assets/img/club/history/'+imgSrc+'.png');
    },
  }
}
</script>
